<script>
import {
  UserProfilePageElementMixin,
} from "%/dynamic-component-editor/standard-pages/user-profile-page/user-profile-page-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "Username",
  extends: TextElement,
  mixins: [UserProfilePageElementMixin],
  elementPanelSettings: {
    displayName: "Username",
    displayIcon: "document",
    elementGroup: "userProfile",
    elementType: "element",
  },
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.entity.username;
    },
  },
};
</script>
